import { render, staticRenderFns } from "./TituloNotas.vue?vue&type=template&id=e9687bc6&"
import script from "./TituloNotas.vue?vue&type=script&lang=js&"
export * from "./TituloNotas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports